/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import theme from '../../../theme';
import { Colors } from '../../theme';

import type { MenuProps } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';

interface StyleProps {
    marginLeft?: boolean;
    marginRight?: boolean;
    noMarginBottom?: boolean;
    error?: boolean;
}

const ErrorText = styled(FormHelperText)({
    color: theme.palette.error.main,
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuPropsConfig = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: '10%',
        },
    },
};

interface DropdownProps extends StyleProps {
    selected: any;
    name?: string;
    error?: boolean;
    errorMessage?: string;
    disabled?: boolean;
    title?: string;
    fields?: any[];
    placeholder?: string;
    wrapText?: boolean;
    disabledUnderline?: boolean;
    style?: React.CSSProperties;
    multiple?: boolean;
    MenuOverrideProps?: Partial<MenuProps>;
    onChange: (event: SelectChangeEvent<any>, child?: React.ReactNode) => void;
}

function getRootSx(props: StyleProps) {
    return {
        marginBottom: props.noMarginBottom ? 0 : '15px',
        marginLeft: props.marginLeft ? '10px' : 0,
        marginRight: props.marginRight ? '10px' : 0,
        width: '100%',
        '& label.Mui-focused': {
            color: !props.error ? theme.palette.primary.main : theme.palette.error.main,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: !props.error ? theme.palette.primary.main : theme.palette.error.main,
        },
        '& .MuiInput-underlines:after': {
            borderBottomColor: !props.error ? theme.palette.primary.main : theme.palette.error.main,
        },
        '&:hover': {
            borderBottomColor: !props.error ? theme.palette.primary.main : theme.palette.error.main,
        },
    };
}

export default function DropDown({
    selected,
    name,
    fields = [],
    onChange = () => {},
    error,
    disabled,
    title,
    placeholder,
    errorMessage,
    wrapText,
    disabledUnderline = false,
    style = {},
    multiple = false,
    MenuOverrideProps,
    ...props
}: DropdownProps) {
    const rootSx = getRootSx({ ...props, error });

    const renderValue =
        selected === undefined && placeholder !== undefined
            ? () => <div style={{ color: Colors.grey }}>{placeholder}</div>
            : undefined;

    return (
        <FormControl sx={rootSx}>
            <InputLabel variant="standard" error={error}>
                {title}
            </InputLabel>
            <Select
                variant="standard"
                style={{ ...style }}
                value={selected === undefined && placeholder !== undefined ? 'unset' : selected}
                onChange={(e, c) => onChange(e, c)}
                inputProps={{
                    name: name ? name : selected,
                }}
                MenuProps={MenuOverrideProps ?? MenuPropsConfig}
                disabled={disabled}
                renderValue={renderValue}
                disableUnderline={disabledUnderline}
                multiple={multiple}
            >
                {fields.length > 0 && fields[0].constructor == Object
                    ? fields.map((field, index) => {
                          return (
                              <MenuItem
                                  key={index}
                                  value={field.key}
                                  style={{ whiteSpace: wrapText ? 'normal' : 'nowrap' }}
                              >
                                  {field.value}
                              </MenuItem>
                          );
                      })
                    : fields.map((field) => {
                          return (
                              <MenuItem
                                  key={field}
                                  value={field}
                                  style={{ whiteSpace: wrapText ? 'normal' : 'nowrap' }}
                              >
                                  {field}
                              </MenuItem>
                          );
                      })}
            </Select>
            <ErrorText>{errorMessage}</ErrorText>
        </FormControl>
    );
}
